module.exports = __webpack_public_path__ + "static/media/userIcon.72cef172.svg";